import React from 'react';
import Container from 'react-bootstrap/Container';
import { Row } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
import { getAssessmentContentBlank } from '../shared/report-util';
import { REPORT_TYPE } from '../../../utils/constants';

function LeaderInstructionsPage2() {
  return (
    <Container className="bg-white mt-2 mb-3 pb-4 candidate-profile-assessments">
      <Container className="m-auto w-75 p-0 pt-5">
        <h4>WORK VALUES FIT</h4>
        <div className="pt-1">
          The Hutrics Work Values Fit (HWVF) is a comparison report that describes your core work values as compared to
          what the organization is currently capable of providing. People tend to be happy and productive in cultures
          that are consistent with their own personal values, and they can be distressed and frustrated working in
          cultures defined by values that differ from their own. Furthermore, your work values will shape the kind of
          culture that you, as a leader, will create for your staff and subordinates.
        </div>
        <div className="pt-2">
          The Overall Work Values Fit is a combined score that provides a summary of the overall alignment between your
          value ratings (on 18 distinct aspects of culture) and what the organization currently provides. Misalignment
          is indicated when you value something significantly more than what the organization provides.
        </div>
        <h4 className="pt-4">ACUMEN</h4>
        <div className="pt-1">
          Hutrics Working Memory (HWM) is taken only by the leader and assesses a leader’s ability to store, focus
          attention on, and manipulate information needed for learning, reasoning, problem-solving, and decision making.
        </div>
        <h4 className="pt-4">EXPERIENCE</h4>
        <div className="pt-1">
          The Hutrics Experiences Inventory (HEI) assesses a leader’s knowledge, skill, and experience on 5 key aspects
          of leadership: Risk-taking, Conflict Resolution, Dealing with Conflict, Meeting Facilitation, and Direct
          Communication. Leaders provide self-report ratings on these key aspects of leadership.
        </div>
        <h4 className="pt-4">JUDGMENT</h4>
        <div className="pt-1">
          The Hutrics Situational Judgment Inventory (HSJI) is taken only by the leader and presents realistic
          work-related situations to assess a leader’s judgment and decision-making related to Building Cohesive Teams,
          Building Resilient Teams, and Executing for Results.
        </div>
        <h4 className="pt-4">COMPETENCIES</h4>
        <div className="pt-1">
          The Hutrics Competency Assessment (HCA) provides self-report and direct report ratings of critical leadership
          competencies. These ratings provide insight into performance, blind-spots, and hidden strengths, which allow a
          leader to identify strengths and focus on targeted developmental areas.
        </div>
        <div className="pt-3 text-bold">Interpreting your scores:</div>
        <div>
          Scores are color-coded to help you easily see where your strengths are and where opportunities can be found.
        </div>
        <Row className="w-100 mx-auto justify-content-center pt-3 pb-3 ps-5">
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 4.25, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">
              Dark blue bars represent a High score on an assessment (e.g., 65th to 99th % tile).
            </div>
          </Stack>
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 3, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">
              Teal blue bars represent an Average score on an assessment (e.g., 36th to 64th % tile).
            </div>
          </Stack>
          <Stack direction="horizontal" className="subscore-chart">
            <div className="w-25">{getAssessmentContentBlank('', 2, undefined, REPORT_TYPE.development)}</div>
            <div className="w-75">Sky blue bars represent a Low score on an assessment (e.g., 1st to 35th % tile).</div>
          </Stack>
        </Row>
        <div>So, if you have Dark Blue, your scores are high on that particular assessment or dimension.</div>
      </Container>
    </Container>
  );
}

export default LeaderInstructionsPage2;
